import { MotifsInjectionSuppState, MotifInjectionSupp } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getAllMotifsVaccinationSupp } from '@/services/api/motifs/api';

import _ from 'lodash';

const namespaced: boolean = true;

export const state: MotifsInjectionSuppState = {
	listMotifsInjectionSupp: []
};

export const mutations: MutationTree<MotifsInjectionSuppState> = {
	mutateMotifsInjectionSupp(state: MotifsInjectionSuppState, newListMotifsInjectionSupp: MotifInjectionSupp[]): void {
		state.listMotifsInjectionSupp = newListMotifsInjectionSupp;
	}
};

export const actions: ActionTree<MotifsInjectionSuppState, RootState> = {
	loadMotifsInjectionSupp(state): Promise<void> {
		return new Promise((resolve, reject) => {
			if (_.isEmpty(state.state.listMotifsInjectionSupp)) {
				getAllMotifsVaccinationSupp()
					.then((response: any) => {
						state.commit('mutateMotifsInjectionSupp', _.get(response, 'data.value.motifsInjectionSupp'));
						resolve();
					})
					.catch(() => {
						reject();
					});
			} else {
				resolve();
			}
		});
	}
};

export const getters: GetterTree<MotifsInjectionSuppState, RootState> = {
	getListMotifsInjectionSupp(state) {
		return state.listMotifsInjectionSupp;
	}
};

export const motifsInjectionSupp: Module<MotifsInjectionSuppState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
